'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/expand/Expand.tsx
import { jsx } from "react/jsx-runtime";
var ExpandIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.66667 2.5C8.66667 2.22386 8.89052 2 9.16667 2H13.5C13.7761 2 14 2.22386 14 2.5V6.83333C14 7.10948 13.7761 7.33333 13.5 7.33333C13.2239 7.33333 13 7.10948 13 6.83333V3.70711L9.52022 7.18689C9.32496 7.38215 9.00838 7.38215 8.81311 7.18689C8.61785 6.99162 8.61785 6.67504 8.81311 6.47978L12.2929 3H9.16667C8.89052 3 8.66667 2.77614 8.66667 2.5ZM2 9.16667C2 8.89052 2.22386 8.66667 2.5 8.66667C2.77614 8.66667 3 8.89052 3 9.16667V12.2929L6.47978 8.81311C6.67504 8.61785 6.99162 8.61785 7.18689 8.81311C7.38215 9.00838 7.38215 9.32496 7.18689 9.52022L3.70711 13H6.83333C7.10948 13 7.33333 13.2239 7.33333 13.5C7.33333 13.7761 7.10948 14 6.83333 14H2.5C2.22386 14 2 13.7761 2 13.5V9.16667Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  ExpandIcon
};
//# sourceMappingURL=chunk-GPJJMW64.mjs.map